__turbopack_context__.v({
  "bz_las_wrap": "Lasso-module-scss-module__Zwo1ma__bz_las_wrap",
});
